export const translateProductType = (type) => {
    switch (type) {
        case "FABRIC": return "KUMAŞ"
        case "PADDED_FABRIC": return "KAPİTONE"
        case "FIBER": return "ELYAF"
    }
}

export const translateStatus = (status) => {
    switch (status) {
        case "PENDING": return "BEKLEMEDE"
        case "IN_PROGRESS": return "İŞLEMDE"
        case "COMPLETED": return "TAMAMLANDI"
    }
}

export const translatePaymentMethod = (method) => {
    switch (method) {
        case "CASH": return "NAKİT"
        case "CREDIT_CARD": return "KREDİ KARTI"
        case "BANK_TRANSFER": return "HAVALE"
        case "CHEQUE": return "ÇEK"
    }
}

export const translatePaymentType = (type) => {
    switch (type) {
        case "PAYMENT": return "Ödeme"
        case "COLLECTION": return "Tahsilat"
    }
}

export const translateRole = (role) => {
    switch (role) {
        case "ADMIN": return "ADMIN"
        case "MANAGER": return "YÖNETİCİ"
        case "DEPOT": return "DEPO"
        case "SALES": return "SATIŞ"
    }
}

export const translatePartnerType = (type) => {
    switch (type) {
        case "SUPPLIER": return "TEDARİKÇİ"
        case "OUTSOURCER": return "FASONCU"
        case "CUSTOMER": return "MÜŞTERİ"
    }
}

